import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'product-reviews',
  name: '商品评价',
  icon: '评',
  group: '商品详情页',
  description: '评价摘要、好评率和精选评价',
  defaultProps: {
    title: '商品评价',
    showSummary: true,
    limit: 3,
    items: [{ nickname: '用户***', content: '商品质量很好，包装完整。', rating: 5 }]
  }
}
